import { render, staticRenderFns } from "./ReviewDrawingTakCard.vue?vue&type=template&id=116ff42c&scoped=true"
import script from "./ReviewDrawingTakCard.vue?vue&type=script&lang=js"
export * from "./ReviewDrawingTakCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewDrawingTakCard.vue?vue&type=style&index=0&id=116ff42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ff42c",
  null
  
)

export default component.exports